import React from 'react';
import PropTypes from 'prop-types';

export default function ProgressBar({
  showProgressBarQuestionIndex = true,
  questionIndex = 0,
}) {
  return (
    <div className="qp-bar clearfix">
      {showProgressBarQuestionIndex && (
        <div id="qp-bar-number" className="qp-bar__number">
          Q{questionIndex}
        </div>
      )}
      <div className="qp-bar__line">
        <div id="progressBar"></div>
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  showProgressBarQuestionIndex: PropTypes.bool,
  questionIndex: PropTypes.number,
};
